(function () {
  'use strict';

  var drawer = document.querySelector('[data-artist-directory]');
  if (!drawer) return;

  var content = drawer.querySelector('[data-artist-directory-content]');
  var search = drawer.querySelector('[data-artist-directory-search]');
  var alphabet = drawer.querySelector('[data-artist-directory-alphabet]');
  var status = drawer.querySelector('[data-artist-directory-status]');
  var endpoint = drawer.getAttribute('data-artist-directory-endpoint');
  var fallbackUrl = drawer.getAttribute('data-artist-directory-fallback-url') || '/collections';
  var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var loaded = false;
  var loadingPromise = null;
  var openerElement = null;
  var returnFocusElement = null;
  var closeTimer = null;
  var mobileOpenTimer = null;
  var itemRecords = [];
  var collator = typeof Intl !== 'undefined' && Intl.Collator
    ? new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
    : null;

  function normalize(value) {
    var normalized = String(value || '');
    if (normalized.normalize) {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return normalized
      .replace(/[Øø]/g, 'o')
      .replace(/[Łł]/g, 'l')
      .replace(/[Ææ]/g, 'a')
      .replace(/[Ðð]/g, 'd')
      .replace(/[Þþ]/g, 't')
      .toLowerCase();
  }

  function compareItems(a, b) {
    if (collator) {
      return collator.compare(a.sortName, b.sortName) || collator.compare(a.name, b.name);
    }
    return a.sortName.localeCompare(b.sortName) || a.name.localeCompare(b.name);
  }

  function groupLetter(value) {
    var normalized = normalize(value).replace(/^[^a-z0-9]+/, '');
    var first = normalized.charAt(0).toUpperCase();
    return /^[A-Z]$/.test(first) ? first : '#';
  }

  function buildAlphabet() {
    var fragment = document.createDocumentFragment();
    letters.forEach(function (letter) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'artist-directory__letter';
      button.textContent = letter;
      button.setAttribute('data-artist-directory-letter', letter);
      button.setAttribute('aria-label', 'Jump to artists beginning with ' + letter);
      button.disabled = true;
      fragment.appendChild(button);
    });
    alphabet.appendChild(fragment);
  }

  function parsePage(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var data = doc.querySelector('.artist-directory-data');
    if (!data) throw new Error('Artist directory data was not found.');

    return {
      pages: Math.max(1, parseInt(data.getAttribute('data-artist-directory-pages'), 10) || 1),
      items: Array.prototype.map.call(data.querySelectorAll('.artist-directory-data__item'), function (item) {
        return {
          name: item.getAttribute('data-artist-name') || item.textContent.trim(),
          sortName: item.getAttribute('data-artist-sort-name') || item.textContent.trim(),
          url: item.getAttribute('href')
        };
      })
    };
  }

  function fetchPage(page) {
    var separator = endpoint.indexOf('?') === -1 ? '?' : '&';
    return fetch(endpoint + separator + 'page=' + page, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Artist directory request failed.');
      return response.text();
    }).then(parsePage);
  }

  function renderItems(items) {
    var unique = {};
    items.forEach(function (item) {
      if (!item.url || unique[item.url]) return;
      unique[item.url] = item;
    });

    itemRecords = Object.keys(unique).map(function (url) {
      return unique[url];
    }).sort(compareItems);

    var groups = {};
    itemRecords.forEach(function (item) {
      var letter = groupLetter(item.sortName);
      if (!groups[letter]) groups[letter] = [];
      groups[letter].push(item);
    });

    var groupsContainer = document.createElement('div');
    groupsContainer.className = 'artist-directory__groups';
    groupsContainer.setAttribute('data-artist-directory-groups', '');

    letters.concat('#').forEach(function (letter) {
      if (!groups[letter]) return;

      var section = document.createElement('section');
      section.className = 'artist-directory__group';
      section.setAttribute('data-artist-directory-group', letter);

      var heading = document.createElement('h3');
      var headingId = 'ArtistDirectoryGroup-' + (letter === '#' ? 'Other' : letter);
      heading.id = headingId;
      heading.className = 'artist-directory__group-title';
      heading.textContent = letter;
      section.setAttribute('aria-labelledby', headingId);
      section.appendChild(heading);

      var list = document.createElement('ul');
      list.className = 'artist-directory__list';

      groups[letter].forEach(function (item) {
        var listItem = document.createElement('li');
        listItem.className = 'artist-directory__item';
        listItem.setAttribute('data-artist-directory-item', '');
        listItem.setAttribute('data-search-text', normalize(item.name + ' ' + item.sortName));

        var link = document.createElement('a');
        link.className = 'artist-directory__link';
        link.href = item.url;
        link.textContent = item.name;

        listItem.appendChild(link);
        list.appendChild(listItem);
      });

      section.appendChild(list);
      groupsContainer.appendChild(section);
    });

    content.innerHTML = '';
    if (itemRecords.length) {
      content.appendChild(groupsContainer);
    } else {
      var empty = document.createElement('p');
      empty.className = 'artist-directory__empty';
      empty.textContent = 'No artist collections are currently available.';
      content.appendChild(empty);
    }
    content.setAttribute('aria-busy', 'false');
    updateFilter();
  }

  function loadDirectory() {
    if (loaded) return Promise.resolve();
    if (loadingPromise) return loadingPromise;

    loadingPromise = fetchPage(1).then(function (firstPage) {
      var requests = [];
      for (var page = 2; page <= firstPage.pages; page += 1) {
        requests.push(fetchPage(page));
      }

      return Promise.all(requests).then(function (remainingPages) {
        var items = firstPage.items.slice();
        remainingPages.forEach(function (pageResult) {
          items = items.concat(pageResult.items);
        });
        renderItems(items);
        loaded = true;
      });
    }).catch(function () {
      content.setAttribute('aria-busy', 'false');
      content.innerHTML = '';

      var error = document.createElement('div');
      error.className = 'artist-directory__error';
      error.setAttribute('role', 'alert');
      var message = document.createElement('p');
      message.appendChild(document.createTextNode('The artist directory could not be loaded. '));
      var link = document.createElement('a');
      link.href = fallbackUrl;
      link.textContent = 'Browse collections instead.';
      message.appendChild(link);
      error.appendChild(message);
      content.appendChild(error);
      status.textContent = 'Unable to load artists.';
    }).finally(function () {
      loadingPromise = null;
    });

    return loadingPromise;
  }

  function updateFilter() {
    var query = normalize(search.value).trim();
    var visibleCount = 0;
    var availableLetters = {};

    drawer.querySelectorAll('[data-artist-directory-group]').forEach(function (group) {
      var groupCount = 0;
      group.querySelectorAll('[data-artist-directory-item]').forEach(function (item) {
        var matches = !query || item.getAttribute('data-search-text').indexOf(query) !== -1;
        item.hidden = !matches;
        if (matches) {
          groupCount += 1;
          visibleCount += 1;
        }
      });

      group.hidden = groupCount === 0;
      if (groupCount) availableLetters[group.getAttribute('data-artist-directory-group')] = true;
    });

    alphabet.querySelectorAll('[data-artist-directory-letter]').forEach(function (button) {
      button.disabled = !availableLetters[button.getAttribute('data-artist-directory-letter')];
    });

    if (!loaded && itemRecords.length === 0) return;
    if (visibleCount === 0 && query) {
      status.textContent = 'No artists match “' + search.value.trim() + '”.';
    } else {
      status.textContent = visibleCount + (visibleCount === 1 ? ' artist' : ' artists');
    }
  }

  function focusableElements() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), [tabindex]:not([tabindex="-1"])'),
      function (element) {
        return !element.hidden && element.offsetParent !== null;
      }
    );
  }

  function closeHeaderDropdowns() {
    document.querySelectorAll('.header__menu .menu__item.is-open').forEach(function (item) {
      var trigger = item.querySelector('.navlink--toplevel[data-top-link]');
      var dropdown = item.querySelector('.header__dropdown');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (dropdown) dropdown.hidden = true;
      item.classList.remove('is-open');
    });
  }

  function visibleHamburgerTrigger() {
    var triggers = document.querySelectorAll('[data-drawer-toggle="hamburger"]');
    for (var i = 0; i < triggers.length; i += 1) {
      if (!triggers[i].closest('[data-drawer="hamburger"]') && triggers[i].offsetParent !== null) {
        return triggers[i];
      }
    }
    return null;
  }

  function openDrawer(opener) {
    window.clearTimeout(closeTimer);
    openerElement = opener;
    returnFocusElement = opener.closest('[data-drawer="hamburger"]')
      ? visibleHamburgerTrigger()
      : opener;
    opener.setAttribute('aria-expanded', 'true');
    closeHeaderDropdowns();
    drawer.hidden = false;
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('artist-directory-is-open');
    content.scrollTop = 0;
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      search.focus();
    });
    loadDirectory();
  }

  function openFromTrigger(opener) {
    var mobileDrawer = opener.closest('[data-drawer="hamburger"]');
    if (mobileDrawer && !mobileDrawer.classList.contains('display-none')) {
      var mobileClose = mobileDrawer.querySelector('.drawer__close[data-drawer-toggle="hamburger"]');
      if (mobileClose) mobileClose.click();
      window.clearTimeout(mobileOpenTimer);
      mobileOpenTimer = window.setTimeout(function () {
        openDrawer(opener);
      }, 520);
      return;
    }
    openDrawer(opener);
  }

  function closeDrawer() {
    if (drawer.hidden) return;
    window.clearTimeout(mobileOpenTimer);
    drawer.classList.remove('is-open');
    document.body.classList.remove('artist-directory-is-open');
    if (openerElement) openerElement.setAttribute('aria-expanded', 'false');
    if (returnFocusElement && document.contains(returnFocusElement)) {
      returnFocusElement.focus();
    }
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    closeTimer = window.setTimeout(function () {
      drawer.hidden = true;
      search.value = '';
      content.scrollTop = 0;
      updateFilter();
      openerElement = null;
      returnFocusElement = null;
    }, 290);
  }

  buildAlphabet();

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-artist-directory-open]');
    if (opener) {
      event.preventDefault();
      openFromTrigger(opener);
      return;
    }

    if (event.target.closest('[data-artist-directory-close]')) {
      event.preventDefault();
      closeDrawer();
    }
  });

  search.addEventListener('input', updateFilter);

  alphabet.addEventListener('click', function (event) {
    var button = event.target.closest('[data-artist-directory-letter]');
    if (!button || button.disabled) return;
    var group = drawer.querySelector('[data-artist-directory-group="' + button.getAttribute('data-artist-directory-letter') + '"]');
    if (group) {
      group.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      var heading = group.querySelector('.artist-directory__group-title');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }
  });

  drawer.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = focusableElements();
    if (!focusable.length) {
      event.preventDefault();
      search.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
